export default "__VITE_ASSET__BbqsrKHo__"